// @ts-nocheck

export const localeCodes =  [
  "en",
  "nl"
]
export const localeLoaders = {
  en: [
    {
      key: "locale_en_46json_14f2c2a3",
      load: () => Promise.resolve({}),
      cache: true
    }
  ],
  nl: [
    {
      key: "locale_nl_46json_beedcf15",
      load: () => Promise.resolve({}),
      cache: true
    }
  ]
}
export const vueI18nConfigs = [
  () => import("#nuxt-i18n/1681e96e" /* webpackChunkName: "config_i18n_46config_46ts_1681e96e" */)
]
export const normalizedLocales = [
  {
    name: "English",
    code: "en",
    language: "en",
    craftSiteHandle: "en",
    craftLanguage: "en-US",
    domains: [],
    defaultForDomains: []
  },
  {
    name: "Nederlands",
    code: "nl",
    language: "nl-NL",
    craftSiteHandle: "nl",
    craftLanguage: "nl",
    domains: [],
    defaultForDomains: []
  }
]

